module.exports = __webpack_public_path__ + "img/login-min.b8fe95bf.png";